import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '../Icon/icon.js';

const Link = ({
  ariaLabel,
  children,
  className,
  hasIconSpacing = true,
  href,
  isDisabled = false,
  isFullWidth = false,
  leftIcon,
  newWindow = false,
  onClick,
  onKeyDown,
  onKeyPress,
  rightIcon,
  testSection,
  variant,
  ...props
}) => {
  if (onKeyPress) {
    console.warn(
      "Warning: The prop 'onKeyPress' is deprecated and will be removed in future versions. Please use 'onKeyDown' instead."
    );
  }
  const classes = classNames(
    {
      [`link--${variant}`]: variant,
      "flex--inline flex-justified--center flex-align--center": leftIcon || rightIcon,
      link: true,
      "link--disabled pointer-events--none": isDisabled,
      "width--1-1 display--inline-block": isFullWidth
    },
    className
  );
  const leftIconComp = leftIcon ? /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames(
        "flex flex-self--center",
        hasIconSpacing && "push-half--right"
      ),
      children: /* @__PURE__ */ jsx(Icon, { className: "axiom-link__left-icon", name: leftIcon, size: "small" })
    }
  ) : null;
  const rightIconComp = rightIcon ? /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames(
        "flex flex-self--center",
        hasIconSpacing && "push-half--left"
      ),
      children: /* @__PURE__ */ jsx(
        Icon,
        {
          className: "axiom-link__right-icon",
          name: rightIcon,
          size: "small"
        }
      )
    }
  ) : null;
  if (isDisabled || !href && !onClick) {
    return /* @__PURE__ */ jsxs(
      "span",
      {
        className: classes,
        "data-oui-component": true,
        "data-test-section": testSection,
        "data-track-id": testSection,
        ...props,
        children: [
          leftIconComp,
          children,
          rightIconComp
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "a",
    {
      "aria-label": ariaLabel,
      className: classes,
      "data-oui-component": true,
      "data-test-section": testSection,
      "data-track-id": testSection,
      href,
      onClick,
      onKeyDown: onKeyDown || onKeyPress,
      ...newWindow ? { rel: "noopener noreferrer", target: "_blank" } : {},
      tabIndex: 0,
      ...props,
      children: [
        leftIconComp,
        children,
        rightIconComp
      ]
    }
  );
};
Link.displayName = "Link";

export { Link as default };
